export default __webpack_public_path__ + "static/media/GR4 2A-1B-1C-2EC.cc4fef20.jpg";